import { imprimirContraProva } from 'modulo-gerencial-erp-pacotes-impressora-termica';

import { imprimirServicoNovo, buscarDadosImpressao } from '../utils';

async function imprimir(id, query = '', usar_nova_impressao = false) {
  /* if (!usar_nova_impressao) {
    return await imprimirServicoAntigo(id, 13, query);
  }

  const dados = await buscarDadosImpressao(id, 13);

  const { comandos } = layout(adapter(dados));

  const response = await imprimirServicoNovo(id, 'contra-prova', comandos);
  return response.data; */

  return await imprimirContraProva({
    id,
    buscarDadosImpressao,
    chamarServicoImpressoraTermica: imprimirServicoNovo,
    query,
  });
}

export default imprimir;
